import { Typography } from '@mui/material';
import { type Variant } from '@mui/material/styles/createTypography';
import * as React from 'react';
import classnames from 'classnames';
import { makeStyles } from 'tss-react/mui';
import { type ITheme } from '../../theme';

export interface HeadingProps {
  title: string;
  subtitle?: string;
  topText?: string;
  titleVariant?: Variant;
  subtitleClassName?: string;
}

const useStyles = makeStyles()((theme: ITheme) => ({
  container: {
    paddingTop: '2rem',
    paddingBottom: '2rem',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '1rem',
      paddingTop: '1rem',
    },
  },
  title: {
    fontSize: '2.25rem',
    lineHeight: '3rem',
    fontWeight: theme.typography.fontWeightBold as number,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
      lineHeight: 'inherit',
    },
  },
  topText: {
    fontSize: '5.75rem',
  },
  subtitle: {
    fontSize: '1.125rem',
    fontWeight: theme.typography.fontWeightLight as number,
    paddingTop: '1rem',
    [theme.breakpoints.down('lg')]: {
      fontSize: '1rem',
    },
  },
}));

const Heading: React.FC<HeadingProps> = ({ titleVariant = 'h1', subtitleClassName, ...props }) => {
  const { classes } = useStyles();
  return (
    <div
      className={classes.container}
      style={{
        textAlign: 'center',
        maxWidth: '640px',
        marginLeft: '1rem',
        marginRight: '1rem',
      }}
    >
      {props.topText && (
        <Typography className={classes.topText} variant="subtitle2">
          {props.topText}
        </Typography>
      )}
      <Typography variant={titleVariant} className={classes.title}>
        {props.title}
      </Typography>
      <Typography
        variant="subtitle1"
        component="p"
        className={classnames(classes.subtitle, {
          [subtitleClassName]: subtitleClassName !== undefined,
        })}
      >
        {props.subtitle}
      </Typography>
    </div>
  );
};

export default Heading;
